

/* Quincux
---------------------------------------------------------------------------------------------------- */

import gsap from 'gsap'
import Wall from './Wall'

export default class Quincux extends Wall {

    detectEdges() {
        const [penultimate, ultimate] = Array.from(this.$refs.brick).slice(-2)
        let offsetY = 0

        if (ultimate) {
            offsetY = Math.abs(penultimate.offsetHeight - ultimate.offsetHeight)
        }

        gsap.set(this.$el, { '--offsetY': `${-offsetY}px` })
    }

}




/* CONSTANTS & HELPERS
---------------------------------------------------------------------------------------------------- */
